<template>
  <div class="popUpWrap dark">
    <section class="popup dark" style="max-width: 544px">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="textArea flex">
          <h5>{{ t('skillCertify-assessment-delete-title') }}</h5>
          <p>
              {{ t('skillCertify-assessment-delete-info-1') }}<br/>
              {{ t('skillCertify-assessment-delete-info-2')}}
          </p>
        </div>
        <input v-model="crossCheckInput" type="text" :placeholder="t('common-delete')"/>
        <div class="btnArea">
          <button class="cancel" @click.stop="onClickClose">{{ t('common-cancel') }}</button>
          <button :class="{ disabled: !isActiveDeleteButton }" @click.stop="onClickRemove">{{ t('common-delete') }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useDialogStore} from '~/store/dialog/dialogStore';
import {useI18n} from '#imports';

const { t } = useI18n();
const dialogStore = useDialogStore();
const crossCheckInput = ref("");

// ASMT-AUTH-06: 평가 삭제 확인 — "Delete" 입력 시에만 확정 버튼 활성
const isActiveDeleteButton = computed(() => {
  return crossCheckInput.value === t('common-delete');
});

const onClickClose = () => {
  dialogStore.close()
}

const onClickRemove = () => {
  if(isActiveDeleteButton.value){
    dialogStore.options.confirm?.event();
    onClickClose();
  }
}
</script>

